/**
 * assessment.js — kurs "Değerlendirme / Final Sınavı" kilidinin TEK doğru kaynaktan
 * hesaplanması için paylaşılan yardımcı.
 *
 * Neden gerekli: CourseDetail (müfredat sekmesi) ve CabinLessonLayout (ders sidebar'ı)
 * aynı kilit durumunu iki farklı formülle hesaplıyordu (backend `enrollment.progress`
 * vs. client-side ders sayımı). Bu, aynı kullanıcının aynı anda bir yerde "kilitli",
 * diğerinde "açık" görmesine yol açabiliyordu. Artık her iki yer de bu fonksiyonu
 * kullanır.
 */

/**
 * isAssessmentUnlocked — final sınav/değerlendirme kartının kilidi açık mı?
 *
 * Kural:
 * - `lessons` boşsa (0 ders) SONUÇ HER ZAMAN false — bir kaynak diğerini "açık"
 *   göstermeye çalışsa bile.
 * - `enrollment.progress` backend'den sayı olarak geldiyse BİRİNCİL kaynak kabul
 *   edilir: `progress >= 100` ise açık.
 * - Aksi halde client-side sayıma düşülür: kursa ait tamamlanan ders sayısı
 *   toplam ders sayısına eşit ya da fazlaysa açık.
 *
 * @param {{
 *   enrollment?: { progress?: number } | null,
 *   lessons?: Array<{ lesson_id: string }>,
 *   completedLessonIds?: string[],
 * }} params
 * @returns {boolean}
 */
export function isAssessmentUnlocked({ enrollment, lessons = [], completedLessonIds = [] } = {}) {
  if (!Array.isArray(lessons) || lessons.length === 0) return false;

  const backendProgress = enrollment?.progress;
  if (typeof backendProgress === 'number' && !Number.isNaN(backendProgress)) {
    return backendProgress >= 100;
  }

  const completedInCourse = completedLessonIds.filter((id) =>
    lessons.some((l) => l.lesson_id === id)
  ).length;
  return completedInCourse >= lessons.length;
}
